<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding leads-conversions-template" v-else-if="loaded" > 
        
        <div class="row" >
            <div class="col-12 ml-0" >
                
                <div class="row" >
    
                    <div class="col-auto" > <span class="h4 font-900 d-inline" style="line-height: 34px; margin-rigth: 15px" > Group results by:  </span> </div>
                    <div class="col" >
                        <multiselect v-model="groupBy" :options="groupResults" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Group results by:"  @input="parseFilteredConversions" class="d-inline-block w-100" :allow-empty="false" >
                    </multiselect>      
                    </div> 
                    
                </div> 
                
            </div>
        </div>
        
        <orderList v-if="tableLoaded && groupBy.value == 'none'" :data="tableData" class="mt-3" ></orderList>
        
        <ordersSources v-else-if="tableLoaded && groupBy.value != 'none'" :data="tableData"  ></ordersSources>
        
    </div>
</template>

<script>    
import Cookies from 'js-cookie'
import modal from '@/components/modal.vue'  
import orderList from '@/components/orders.vue'  
import ordersSources from '@/components/orders-sources.vue'  
import helper from '@/helpers/helpers.js';
    
export default{
    name: "orders-wrapper",
    props: {
        passed_organizationID: { 
            type: [String],
        },
        data: { 
            type: [Array],
        },
        page:{
            type:[String],
            default: "orders"
        }
    },
    components:{
        orderList,
        ordersSources,
        modal: () => {import('@/components/modal.vue')},
    },
    data () {
        return {
            filter: '',
            loaded: false,
            modalData: null,
            modalState: false,
            
            tableLoaded: false,
            tableData: [],
            groupResults: [
                
                {
                    text: "None",
                    value: "none"
                }
                
            ],
            groupBy: {
                text: "None",
                value: "none"
            },
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        //console.log(this.data)
        //console.log(this.page)

        this.data.forEach((order)=>{
            let parameters = []
            order.touchpoints.forEach((touchpoint)=>{
                if( touchpoint.params ){
                    Object.keys(touchpoint.params).forEach((key)=>{ 
                        //console.log(key); // alerts key 
                        //console.log(touchpoint.params[key]); // alerts value

                        parameters.push( { key: key, value: touchpoint.params[key] } )

                        let found = this.groupResults.find(el => el.value == key )
                        if( found == undefined ){
                             this.groupResults.push( { text: key+" parameter", value: key } )
                        }
                    });
                }
            })
            order.parameters = parameters
            //console.log(parameters)
        })

        this.parseFilteredConversions()

    },
    computed: {
    },
    methods: {
        
        parseFilteredConversions(){
            
            
            this.tableLoaded = false
            
            //console.log( this.groupBy.value )
            
            this.tableData = []
            
            if( this.groupBy.value == 'none' ){
                this.data.forEach((item)=>{ this.tableData.push(item) })
                this.tableData.sort((a, b) => a.datetime - b.datetime);
            }else if( this.groupBy.text.includes('parameter') ){
                this.groupResultsBy( this.groupBy.value, this.data );
                this.tableData.sort((a, b) => b.conversions.length - a.conversions.length);
            }
            
            //console.log( this.tableData )
            
            this.loaded = true;
            //this.tableLoaded = true;
            setTimeout(function(){ this.tableLoaded = true }.bind(this), 100 );
            
        },
        
        groupResultsBy( type, data ){
            
            let results = []
            //URL PARAMETERS
            data.forEach((item)=>{
                //console.log(item)
                let NAME = "No "+type+" parameter"                
                if( item.parameters.find(el => el.key == type ) ){
                    let p = item.parameters.find(el => el.key == type )
                    NAME = p.value
                }
                
                //console.log(NAME)
                //let found = results.find(el => el.previousURL.includes( previousURLDomain ) )
                let found = results.find(el => el.name == NAME )
                
                if( found == undefined ){

                    let SOURCE = { name: NAME, conversions:[ ] }
                    SOURCE.conversions.push( item )

                    results.push( SOURCE );

                }else{

                    for( var i = 0; i < results.length; i++ ){
                        if( results[i].name == NAME  ){
                            results[i].conversions.push( item )                                
                        }
                    }

                }

            })
            //URL PARAMETERS
            
            this.tableData = results
            return results
            
        }
        

    },
    computed:{
    },
}
</script>

<style lang="scss" >
    
     @import '@/assets/css/atlass-datatable.scss';
     @import '@/assets/css/atlass-modal.scss';
    
    .html-circle{
        font-size: 18px;
        line-height: 14px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/orders-wrapper.vue